import { actions as mainActions } from "../../config/reduxIndex";

export const types = {
	SET_DEFAULT: 'SHIP_TO/SET_DEFAULT',
	SET_ATTRIBUTE_BY_OBJ: 'SHIP_TO/SET_ATTRIBUTE_BY_OBJ'
}

const defaultState = {
	shipTo: null,
	shipToMethod: 'select'
}

export default (state = defaultState, action) => {
	switch(action.type) {
		case types.SET_DEFAULT:
			return defaultState;
		case types.SET_ATTRIBUTE_BY_OBJ:
			return Object.assign({}, state, action.obj);
		default:
			return state;
	}
}

export const actions = {
	setDefault: () => {
		return {type: types.SET_DEFAULT};
	},
	setAttributeByObj: (obj) => {
		return {type: types.SET_ATTRIBUTE_BY_OBJ, obj};
	},
	selectShipTo: (shipTo, propagateTo) => {
		return (dispatch) => {
			const propagateChange = {
				shipTo
			};
			const shipToChange = {
				shipTo,
				shipToMethod: "display"
			};
			dispatch(actions.setAttributeByObj(shipToChange));
			dispatch(mainActions[propagateTo].setAttributeByObj(propagateChange));
		};
	}
}


// WEBPACK FOOTER //
// ./src/redux/quick-entry/shipTo.js